import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { ClientLogsService } from './client-logs.service';
import { describeApplicationError, diagnosticPagePath } from '../../shared/utils/application-error-diagnostic';

@Injectable()
export class LogsErrorHandler extends ErrorHandler {
  private lastReportedAt = 0;
  constructor(private injector: Injector) { super(); }
  override handleError(error: unknown): void {
    try {
      const diagnostic = describeApplicationError(error);
      if (diagnostic && Date.now() - this.lastReportedAt > 5000) {
        this.lastReportedAt = Date.now();
        const logs = this.injector.get(ClientLogsService);
        const metadata: Record<string, string | number> = { errorCode: diagnostic.errorCode };
        if (logs.supportsApplicationErrorDetails()) {
          metadata['errorName'] = diagnostic.errorName;
          if (diagnostic.errorMessage) metadata['errorMessage'] = diagnostic.errorMessage;
          const router = this.injector.get(Router, null);
          const pagePath = router && diagnosticPagePath(router.routerState.snapshot);
          if (pagePath) metadata['pagePath'] = pagePath;
        }
        logs.record('APPLICATION_ERROR', metadata, 'APPLICATION_FAILURE');
      }
    } catch { /* Diagnostic failures must never recurse. */ }
    super.handleError(error);
  }
}
